import DashboardLayout from "@/layout/dashboard/DashboardLayout.vue";

// GeneralViews
import Login from "@/pages/Auth/Login.vue";
import ForgotPassword from "@/pages/Auth/ForgotPassword.vue";
import ResetPassword from "@/pages/Auth/ResetPassword.vue";
import ConfirmAccount from "@/pages/Auth/ConfirmAccount.vue";
import NotFound from "@/pages/NotFoundPage.vue";

// Admin pages
import UserProfile from "@/pages/UserProfile.vue";
import Users from "@/pages/Users.vue";
import LicensePools from "@/pages/LicensePools.vue";
import RequestLicense from "@/pages/RequestLicense.vue";
import Transactions from "@/pages/Transactions.vue";
import Downloads from "@/pages/Downloads.vue";
import DeviceLinkReports from "@/pages/DeviceLinkReports.vue";
import DeviceLinkReport from "@/pages/DeviceLinkReport.vue";

import config from '../config';

const routes = [
  {
    path: "/login",
    name: "login",
    component: Login,
    meta: {
      requiresAuth: false
    }
  },
  {
    path: "/forgot-password",
    name: "forgot-password",
    component: ForgotPassword,
    meta: {
      requiresAuth: false
    }
  },
  {
    path: "/reset-password",
    name: "reset-password",
    component: ResetPassword,
    meta: {
      requiresAuth: false
    }
  },
  {
    path: "/confirm-account",
    name: "confirm-account",
    component: ConfirmAccount,
    meta: {
      requiresAuth: false
    }
  },
  {
    path: "/",
    component: DashboardLayout,
    name: "",
    meta: {
      requiresAuth: true
    },
    children: [
      {
        path: "profile",
        name: "user profile",
        component: UserProfile
      },
      {
        path: "users",
        name: "user management",
        component: Users,
        meta: {
          roles: [ config.SUPERUSER, config.STAFF_USER, config.MANAGER ]
        }
      },
      {
        path: "licenses",
        name: "license management",
        component: LicensePools,
        meta: {
          roles: [ config.SUPERUSER, config.STAFF_USER, config.MANAGER ]
        }
      },
      {
        path: "request-license",
        name: "request licenses",
        component: RequestLicense
      },
      {
        path: "transactions/:poolId",
        name: "transaction history",
        component: Transactions,
        props: true
      },
      {
        path: "downloads",
        name: "downloads",
        component: Downloads
      },
      {
        path: "device-link/reports",
        name: "device link reports",
        component: DeviceLinkReports
      },
      {
        path: "device-link/reports/:id",
        name: "device link report",
        component: DeviceLinkReport,
        props: true
      }
    ]
  },
  { path: "*", component: NotFound }
];

/**
 * Asynchronously load view (Webpack Lazy loading compatible)
 * The specified component must be inside the Views folder
 * @param  {string} name  the filename (basename) of the view to load.
function view(name) {
   var res= require('../components/Dashboard/Views/' + name + '.vue');
   return res;
};**/

export default routes;
